<div class="main-content" style="overflow: hidden">
  <!-- left side with forms -->
  <div class="left-content">
    <img src="../../../assets/img/complete-logo.svg" alt="WeCloud Logo" class="logo-top">
    <div class="form-container">
      <i (click)="goToLogin()" nz-icon nzType="arrow-left" nzTheme="outline" class="icon-return"></i>
      @if(currentStep === 0) {
         <div class="form-header">
        <h1>Esqueceu sua senha?</h1>
        <p>Uma nova senha vai ser enviada para seu e-mail</p>
      </div>
      <div class="form-body">
        <div class="card-body input-code">
          <div class="input-container">
              <span>E-mail</span>
              <div class="input-field">
                <i nz-icon nzType="user" nzTheme="outline" class="input-icon"></i>
                <input type="text" placeholder="Digite seu e-mail" [formControl]="forgotForm.get('email')">
              </div>
              <span class="input-error" *ngIf="forgotForm.get('email').hasError('email') && !forgotForm.get('email').hasError('required')">
                Insira um e-mail válido para continuar
              </span>
              <span class="input-error" *ngIf="forgotForm.get('email').hasError('required') && forgotForm.get('email').touched">
                E-mail é <strong>obrigatório!</strong>
              </span>
          </div>
          <div class="input-container" style="margin-top: 24px;">
          </div>
          <div class="actions-group">
              <button (click)="forgotPassword()" class="button">Recuperar senha <span nz-icon nzType="loading" nzTheme="outline" *ngIf="loading" class="loading-icon"></span></button>
          </div>
        </div>
      </div>
      }
      @if(currentStep === 1) {
        <div class="form-header">
          <h1>Esqueceu sua senha?</h1>
          <p>Digite o código de verificação que enviamos para o e-mail <span style="font-weight: bold;">{{email}}</span></p>
        </div>
        <div class="form-body">
          <div class="card-body input-code">
            <div class="code-container">
                <span class="verify-code-text">Código de verificação</span>
              <code-input class="mt-3" #codeInput [codeLength]="6" (codeCompleted)="onCodeCompleted($event)" (codeChanged)="onCodeChanged($event)">
              </code-input>
              <div class="flex flex-col items-start mt-4">
                <div class="error-code" *ngIf="codeError">
                  <span>*Código digitado inválido, preencha<br>novamente o código recebido.</span>
                </div>
                <span *ngIf="!resetEmail" class="email-seconds">Você pode reenviar o código<br>em <strong><span id="timer"></span> segundos</strong></span>
                <div *ngIf="resetEmail">
                  <span style="cursor: pointer;" class="title-style email-seconds renv-email" [ngClass]="loading || envitedEmail ? 'disabled' : ''" (click)="forgotPassword()">Reenviar código</span>
                  <span class="title-style email-seconds renv-email" *ngIf="loading">
                    <i nz-icon nzType="loading" nzTheme="outline"></i>
                  </span>
                  <span *ngIf="!loading && envitedEmail" class="title-style email-seconds renv-email">
                    <i nz-icon nzType="check-circle" nzTheme="outline" style="margin-right: 0.5rem;"></i> <span>Código reenviado</span>
                  </span>
                </div>
              </div>
          </div>
          <div class="actions-group">
              <button (click)="goToPassword()" class="button">Redefinir senha <span nz-icon nzType="loading" nzTheme="outline" *ngIf="loading" class="loading-icon"></span></button>
          </div>
          <span class="text-info-code mt-6 block">Não recebeu o código? Verifique o spam ou tente outro endereço de e-mail.</span>
        </div>
      </div>
      }
      @if(currentStep === 2) {
         <div class="form-header">
        <h1>Criar nova senha</h1>
        <p>Crie uma nova senha para acessar sua conta</p>
      </div>
      <div class="form-body">
        <div class="card-body input-code">
          <div class="input-container">
            <span>Nova senha</span>
            <div class="input-field">
              <i nz-icon nzType="lock" nzTheme="outline" class="input-icon"></i>
              <input [type]="hide ? 'password' : 'text'" [formControl]="forgotForm.get('password')" placeholder="Digite sua senha">
              <i nz-icon [nzType]="hide ? 'eye-invisible' : 'eye'" nzTheme="outline" (click)="hide = !hide" class="clickable end-icon"></i>
            </div>
            <span class="input-error" *ngIf="forgotForm.get('password').hasError('required') && forgotForm.get('password').touched">
              Senha é <strong>obrigatório!</strong>
            </span>
          </div>
          <div class="input-container" style="margin-top: 24px;">
            <span>Confirmar nova senha</span>
            <div class="input-field">
              <i nz-icon nzType="lock" nzTheme="outline" class="input-icon"></i>
              <input [type]="hide ? 'password' : 'text'" [formControl]="forgotForm.get('confirm')" placeholder="Digite sua senha">
              <i nz-icon [nzType]="hide ? 'eye-invisible' : 'eye'" nzTheme="outline" (click)="hide = !hide" class="clickable end-icon"></i>
            </div>
            <span class="input-error" *ngIf="forgotForm.get('confirm').hasError('required') && forgotForm.get('confirm').touched">
              Senha é <strong>obrigatório!</strong>
            </span>
          </div>
          <mat-error *ngIf="forgotForm.get('confirm').hasError('required') && forgotForm.get('confirm').touched">
            Confirmar senha <strong>é requerido<br></strong>
          </mat-error>
          <mat-error *ngIf="confirmation">
            Senhas <strong>não conferem!</strong>
          </mat-error>

          <div class="error-code" *ngIf="forgotForm.get('password').invalid && (forgotForm.get('password').dirty || forgotForm.get('password').touched)">
                    <span>*Sua senha deve conter ao menos
                      <span *ngIf="forgotForm.get('password').errors.minlength">8 caracteres, </span>
                      <span *ngIf="forgotForm.get('password').errors.lowerCaseError;">1 letra minúscula, </span>
                      <span *ngIf="forgotForm.get('password').errors.upperCaseError;">1 letra maiúscula, </span>
                      <span *ngIf="forgotForm.get('password').errors.numberError;">1 número, </span>
                      <span *ngIf="forgotForm.get('password').errors.symbolError;">1 caractere especial (ex: !&#64;#$%&*)</span>.
                    </span>
                </div>

          <div class="actions-group">
              <button (click)="confirmNewPassword()" class="button">Salvar <span nz-icon nzType="loading" nzTheme="outline" *ngIf="loading" class="loading-icon"></span></button>
          </div>
        </div>
      </div>
      }
    </div>
    <footer class="left-footer">
    <span>© {{ today | date: 'yyyy' }} Powered by WeSafer</span>
  </footer>
  </div>
  <!-- right side with image -->
  <div class="right-content">
    <div class="image-container">
      <img src="../../../assets/img/login-main-image.svg" alt="Login Image" />
    </div>
  </div>
</div>
